export type NewsItem = {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  cover: string;
  content: string[];
};

export const newsList: NewsItem[] = [
  {
    id: 'n-001',
    title: '《银河彼岸》全球首周票房破 3 亿美元，科幻大片热度持续攀升',
    date: '2025-10-12',
    category: '票房动态',
    summary: '由埃里克·诺兰执导的科幻巨制《银河彼岸》上周末登陆全球院线，首周票房突破 3 亿美元，成为本年度开局最强劲的原创科幻电影。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20premiere%20red%20carpet%20scene%20with%20deep%20blue%20spotlights%20and%20warm%20orange%20accents%2C%20glamorous%20media%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-001&orientation=landscape',
    content: [
      '据最新统计数据，科幻电影《银河彼岸》在全球上映首周便斩获超过 3 亿美元票房，成为本年度开局表现最亮眼的原创科幻作品。多个市场的排片占比在上映第三天出现逆势增长。',
      '业内人士分析认为，该片之所以能迅速聚拢人气，与其扎实的世界观设定和克制的情感表达密不可分。影片并没有依赖于密集的视觉奇观，而是把重心放在了人物的孤独与选择上。',
      '导演埃里克·诺兰在采访中表示，团队用了将近三年时间打磨剧本，希望观众在走出影院时，记住的不只是画面，而是那份“人类依然愿意相信彼此”的微弱希望。',
      '随着口碑持续发酵，多家影院已经增加了黄金场次的排片。业内预计该片有望在接下来的几周继续保持强劲走势。',
    ],
  },
  {
    id: 'n-002',
    title: '年度悬疑佳作《雾都追凶》宣布延长放映，口碑票房双丰收',
    date: '2025-10-10',
    category: '影片动态',
    summary: '《雾都追凶》凭借扎实的剧本与出色的表演收获大量好评，片方今日宣布将延长院线放映周期，并追加多场特别放映活动。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20foggy%20city%20street%20at%20night%20with%20deep%20blue%20tone%20and%20warm%20orange%20streetlamp%20glow%2C%20mysterious%20noir%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-002&orientation=landscape',
    content: [
      '悬疑电影《雾都追凶》自上映以来口碑持续走高，片方于今日正式宣布延长院线放映周期，并在多个城市追加特别放映与主创映后交流活动。',
      '影片以一桩沉寂十年的旧案为线索，用大量的留白与环境音塑造出独特的压迫感。不少观众表示，影片最动人的地方在于它始终没有把“真相”当成唯一的答案。',
      '主演张弼在片中有一段长达三分钟的无台词独白，被影迷称为“年度最安静的爆发”。导演林嘉树透露，这场戏几乎是一次拍摄完成。',
    ],
  },
  {
    id: 'n-003',
    title: '第 38 届国际电影节公布入围名单，多部华语影片入选主竞赛单元',
    date: '2025-10-08',
    category: '行业资讯',
    summary: '本届国际电影节主竞赛单元入围名单正式揭晓，多部华语影片名列其中，涵盖剧情、历史与现实题材，引发广泛关注。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20festival%20award%20ceremony%20stage%20with%20deep%20blue%20backdrop%20and%20warm%20orange%20spotlights%2C%20elegant%20formal%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-003&orientation=landscape',
    content: [
      '第 38 届国际电影节今日公布主竞赛单元入围名单，多部华语影片成功入选，题材覆盖历史、现实与家庭叙事，展现出华语电影多元的创作面貌。',
      '评审团主席在发布会上表示，今年的入围作品普遍呈现出更强的“个人视角”，创作者们更愿意从小切口进入宏大的时代命题。',
      '除了主竞赛单元，本届电影节还设置了新导演、纪录片等多个展映板块，为不同类型的作品提供了展示平台。',
    ],
  },
  {
    id: 'n-004',
    title: '《深海之息》幕后特辑曝光：每一帧都像一首流动的诗',
    date: '2025-10-05',
    category: '幕后揭秘',
    summary: '动画电影《深海之息》发布最新幕后特辑，首次公开了海底世界从概念设计到最终渲染的完整创作流程。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20deep%20sea%20concept%20art%20workstation%20with%20glowing%20orange%20creatures%20and%20deep%20blue%20water%2C%20creative%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-004&orientation=landscape',
    content: [
      '《深海之息》官方发布最新幕后特辑，首次向观众展示了海底世界从最初的手绘草图，到三维建模，再到最终光影渲染的完整流程。',
      '主创团队透露，影片中的每一种发光生物都参考了真实的深海生物形态，仅主角潜水服的色彩方案就修改了超过二十个版本。',
      '艺术总监安娜·贝尔表示：“我们希望观众在观影时，能感受到水压、光线和温度的变化，而不只是看到一个漂亮的海底。”',
    ],
  },
  {
    id: 'n-005',
    title: '2025 年秋季档前瞻：现实题材与类型片并行的多元化格局',
    date: '2025-10-02',
    category: '行业资讯',
    summary: '随着多部备受期待的新片定档，2025 年秋季档呈现出类型多元、内容扎实的特点，现实题材与商业类型片形成良性互补。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20autumn%20city%20skyline%20at%20dusk%20with%20deep%20blue%20shadows%20and%20warm%20orange%20sunset%20light%2C%20calm%20panoramic%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-005&orientation=landscape',
    content: [
      '进入十月，2025 年秋季档正式拉开序幕。从目前公布的定档信息来看，本季度的片单呈现出清晰的多元化格局。',
      '一方面，多部聚焦普通人生活的现实题材影片备受期待；另一方面，科幻、悬疑等类型片也在持续拓展叙事边界，两者共同构成了健康的市场生态。',
      '有院线经理表示，观众的选择正在变得更加理性，口碑对票房走势的影响比以往任何时候都更明显。',
    ],
  },
  {
    id: 'n-006',
    title: '《长安月》美术设计解析：一座被光影重新唤醒的古城',
    date: '2025-09-28',
    category: '幕后揭秘',
    summary: '《长安月》的美术团队分享了古城场景的搭建思路，如何用色彩与光影在镜头中还原一个既真实又富有想象力的时代。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20city%20at%20night%20with%20warm%20orange%20lanterns%20and%20deep%20blue%20sky%2C%20artistic%20production%20design%20scene%2C%20high%20detail&width=800&height=500&seq=news-cover-006&orientation=landscape',
    content: [
      '《长安月》的美术团队在最新分享中，详细拆解了片中几场重要夜戏的布景逻辑，解释了如何用有限的灯光预算营造出宏大的时代质感。',
      '团队表示，古城的街道并非一味追求“复古”，而是刻意在细节中加入了生活化的痕迹，比如晾晒的衣物、斑驳的墙皮，让场景更有人情味。',
      '在色彩上，影片以深蓝作为夜晚的主基调，用暖橙色的灯笼作为情绪的点缀，形成冷暖之间的张力。',
    ],
  },
  {
    id: 'n-007',
    title: '多部影片宣布定档贺岁档，年终市场争夺战提前打响',
    date: '2025-09-25',
    category: '影片动态',
    summary: '随着贺岁档临近，多部重量级影片陆续公布档期，围绕年终市场的排片与营销竞争已经提前展开。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20festive%20winter%20city%20street%20at%20night%20with%20warm%20orange%20lights%20and%20deep%20blue%20snow%2C%20festive%20hopeful%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-007&orientation=landscape',
    content: [
      '距离年末还有两个多月，但贺岁档的竞争已经提前升温。多部备受关注的影片陆续公布定档信息，排片与宣发资源成为各家争夺的焦点。',
      '与往年相比，今年的定档策略显得更加谨慎，不少片方选择先通过点映积累口碑，再根据反馈调整上映节奏。',
      '业内普遍认为，内容质量仍将是决定年终市场表现的关键因素。',
    ],
  },
  {
    id: 'n-008',
    title: '新锐导演扶持计划启动，为年轻创作者提供更多可能',
    date: '2025-09-20',
    category: '行业资讯',
    summary: '一项面向青年导演的扶持计划正式启动，将通过资金、拍摄资源与发行渠道等多方面支持，帮助更多新人完成第一部作品。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20young%20filmmakers%20with%20camera%20on%20a%20film%20set%20with%20deep%20blue%20lighting%20and%20warm%20orange%20accents%2C%20creative%20hopeful%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-008&orientation=landscape',
    content: [
      '一项面向青年导演的扶持计划今日正式启动，计划以三年为周期，通过项目孵化、拍摄资源支持与发行渠道对接，帮助新导演完成自己的首部长片。',
      '主办方表示，扶持计划不仅关注资金，更在意创作者能否获得完整的行业经验，因此会为入选者配备经验丰富的制片团队。',
      '首批入选项目覆盖剧情、纪录片与动画等多个方向。',
    ],
  },
  {
    id: 'n-009',
    title: '《夏日回响》重映定档：那些没能说出口的夏天再次来临',
    date: '2025-09-15',
    category: '影片动态',
    summary: '口碑爱情片《夏日回响》宣布推出修复重映版，影片将以更细腻的画面重回大银幕，带观众重温那个漫长的夏天。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20seaside%20train%20platform%20at%20golden%20sunset%20with%20warm%20orange%20glow%20and%20deep%20blue%20sea%2C%20nostalgic%20romantic%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-009&orientation=landscape',
    content: [
      '经典爱情片《夏日回响》宣布推出修复重映版，将于下月重回大银幕。此次重映不仅修复了画面，也重新调整了部分配乐。',
      '导演佐藤遥在寄语中写道：“有些话在夏天没能说出口，但时间会替我们保存它们。”',
      '不少观众表示，希望能在电影院里补上当年错过的那个结尾。',
    ],
  },
  {
    id: 'n-010',
    title: '电影配乐专题：当旋律成为叙事的一部分',
    date: '2025-09-10',
    category: '幕后揭秘',
    summary: '从主题旋律到环境音效，配乐正在成为越来越多作品不可或缺的叙事手段。本期专题带你走进电影声音的幕后世界。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20orchestra%20recording%20studio%20with%20deep%20blue%20lighting%20and%20warm%20orange%20accent%20glow%2C%20elegant%20music%20production%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-010&orientation=landscape',
    content: [
      '在越来越多的作品中，配乐不再只是画面的陪衬，而是承担起塑造情绪、暗示剧情甚至推动叙事的功能。',
      '多位作曲家在接受采访时表示，最好的电影音乐往往“听不见”，却又无处不在，它引导观众的呼吸，也决定了情绪的走向。',
      '本期专题梳理了几部代表性作品的配乐设计思路，带你感受旋律背后的叙事逻辑。',
    ],
  },
];